module.exports = __webpack_public_path__ + "static/media/galdisa_banner3.1cffa1d0.jpg";